export class JcAppRoutingUtils {

    static extractUrlParams(route: string, pattern: string): Record<string, string> {
        // Remove query string from route for path matching
        const routePath = route.split('?')[0];
        const routeParts = routePath.split('/').filter(Boolean);
        const patternParts = pattern.split('/').filter(Boolean);
        const params: Record<string, string> = {};

        for (let i = 0; i < patternParts.length; i++) {
            const patternPart = patternParts[i];
            const routePart = routeParts[i];

            if (patternPart.startsWith(':')) {
                const paramName = patternPart.replace(':', '').replace('?', ''); // Handle optional params
                if (routePart) {
                    params[paramName] = routePart;
                }
            }
        }

        return params;
    }

    static extractQueryParams(route: string): Record<string, string> {
        const params: Record<string, string> = {};

        // Extract query string
        const queryString = route.split('?')[1];
        if (!queryString) {
            return params;
        }

        // Parse query parameters
        const searchParams = new URLSearchParams(queryString);
        searchParams.forEach((value, key) => {
            params[key] = value;
        });

        return params;
    }

    /**
     * Checks if a route matches a pattern
     */
    static matchesPattern(route: string, pattern: string): boolean {
        const routePath = route.split('?')[0];
        const routeParts = routePath.split('/').filter(Boolean);
        const patternParts = pattern.split('/').filter(Boolean);

        // Handle exact match for root path
        if (routePath === '/' && pattern === '/') {
            return true;
        }

        // Check if the number of parts match (considering optional params)
        const requiredPatternParts = patternParts.filter(part => !part.endsWith('?'));
        if (routeParts.length < requiredPatternParts.length) {
            return false;
        }

        // Check each part
        for (let i = 0; i < patternParts.length; i++) {
            const patternPart = patternParts[i];
            const routePart = routeParts[i];

            if (patternPart.startsWith(':')) {
                // Parameter - always matches if present, or if optional
                if (!routePart && !patternPart.endsWith('?')) {
                    return false;
                }
            } else {
                // Literal - must match exactly
                if (patternPart !== routePart) {
                    return false;
                }
            }
        }

        return true;
    }
}
